export default {
  login(credentials) {
    return window.$request.post('/Security/api/Account/Login', credentials)
  },
  register(credentials) {
    return window.$request.post('/Security/api/Account/Register', {
      Name: credentials.name,
      Surname: credentials.surname,
      Email: credentials.email,
      userRole: credentials.userRole,
      ProjectId: credentials.projectId,
    })
  },
  logout() {
    return window.$request.post('/Security/api/Account/Logout')
  },
  // eslint-disable-next-line no-unused-vars
  getUserData() {
    return window.$request.get(`/CRM/api/User/GetUser`)
  },
  changeEmailVerify(query, token) {
    return window.$request.post(
      `/Identity/api/UserProfile/confirmEmailUpdate/${query.oldEmail}/${query.newEmail}`,
      {
        token,
      }
    )
  },
  resetPasswordVerify(email, token) {
    return window.$request.post(
      `/Security/api/Account/forgotPasswordConfirmation/${email}`,
      {
        token,
      }
    )
  },
  updateUserData(data, userId) {
    return window.$request.put(
      '/Identity/api/UserProfile/UpdateMyProfile/' + userId,
      {
        Phone: data.phone,
        Name: data.name,
        Surname: data.surname,
        Email: data.email,
        isAnon: data.isAnon,
        isNotifications: data.isNotifications,
      }
    )
  },
  fetchRoles() {
    return window.$request.get('/Identity/api/Role/GetRolesWithPerms')
  },
  fetchOrders(payload) {
    return window.$request.post(
      '/CRM/api/Home/GetListOfLeads',
      payload.paginationData.statusId != 0
        ? {
            pageSize: +payload.paginationData.perPage,
            statusId: +payload.paginationData.statusId,
            pageNumber: +payload.paginationData.currentPage,
          }
        : {
            pageSize: payload.paginationData.perPage,
            pageNumber: payload.paginationData.currentPage,
          }
    )
  },
  fetchOrder(id) {
    return window.$request.post('/CRM/api/Home/GetLead/', {
      Offer_id: parseInt(id),
    })
  },
  reassignSeller(payload) {
    return window.$request.post('/CRM/api/Home/AssignOfferWithNewUser', {
      offerId: payload.offerId,
      sellerEmail: payload.sellerEmail,
    })
  },
  fetchStatuses() {
    return window.$request.get('/CRM/api/Home/GetStatuses')
  },
  changeStatus(orderId, statusId) {
    return window.$request.put('/CRM/api/Home/ChangeStatus', {
      Offer_id: orderId,
      Status_id: statusId,
    })
  },
  anonymize(orderId) {
    return window.$request.post('/CRM/api/Home/RODOCustomer', {
      Customer_id: orderId,
      Desc: 'prośba',
    })
  },
  addComment(orderId, comment) {
    return window.$request.post('/CRM/api/Home/AddComment', {
      Offer_id: parseInt(orderId),
      Comment: comment,
    })
  },
  fetchUsers() {
    return window.$request.get('/CRM/api/User/GetUsers')
  },
  fetchUserStatuses() {
    return window.$request.get('/CRM/api/UserStatus/GetStatuses')
  },
  changeUserStatus(userId, statusId) {
    return window.$request.put(
      `/CRM/api/User/UpdateUserStatus/${statusId}/${userId}`
    )
  },
  changeUserRole(userId, roleName) {
    return window.$request.put(`/Identity/api/Role/UpdateUserRole/${userId}`, {
      RoleName: roleName,
    })
  },
  updateRole(permList, roleName) {
    return window.$request.put(`/Identity/api/Role/Update/${roleName}`, {
      PermissionsInRole: permList,
    })
  },
  deleteRole(roleName) {
    return window.$request.delete(`/Identity/api/Role/Delete/${roleName}`)
  },
  addRole(data) {
    return window.$request.post(`/Identity/api/Role/Create`, {
      RoleName: data.roleName,
      RoleDescription: data.roleDescription,
      PermissionsInRole: data.permlist,
    })
  },
  changePassword(data) {
    return window.$request.post('/Security/api/Account/ChangePassword', {
      OldPassword: data.oldPass,
      NewPassword: data.newPass,
      NewPasswordConfirmation: data.newPass,
    })
  },
  resetPassword(email) {
    return window.$request.post(`/Security/api/Account/ForgotPassword`, {
      Email: email,
    })
  },
  verifyEmail(query) {
    return window.$request.post(`/Security/api/Account/Confirm${query}`)
  },
  verifyEmail1(token, query) {
    return window.$request.post(`/Security/api/Account/confirmEmail${query}`, {
      token,
    })
  },
  getRaport(dateRange) {
    return window.$request.post(
      'CRM/api/Home/getraport',
      {
        from: dateRange.from,
        to: dateRange.to,
      },
      {
        responseType: 'blob',
      }
    )
  },
  getRaportPdf(id) {
    return window.$request.post(
      'CRM/api/Home/generateReport',
      {
        id,
      },
      {
        responseType: 'blob',
      }
    )
  },
  fetchProjects() {
    return window.$request.get('CRM/api/Project/GetAllProjects')
  },
  fetchRolesForRegister() {
    return window.$request.get('/Identity/api/Role/GetRolesForRegistration')
  },
  fetchUserExternalLinks() {
    return window.$request.get('/CRM/api/ExternalLink/GetUserLinks')
  },
  addExternalLink(name) {
    return window.$request.put('/CRM/api/ExternalLink/AddExternalLink', {
      name: name,
    })
  },
  deleteExternalLink(id) {
    return window.$request.delete(
      `/CRM/api/ExternalLink/DeleteExternalLink?externalLinkId=${id}`
    )
  },
}
